import { FormControl } from "@mui/material"
import { memo, useCallback } from "react"
import { useTranslation } from "react-i18next"
import CustomAsyncAutocomplete from "../../../../../core-components/theme/components/CustomAsyncAutoComplete"
import { UserGroup } from "../../../types"
import { fetchUsersForEscalation } from "../hooks/useEscalationForm"

interface UserGroupSectionProps {
  value: any
  defaultOptions?: UserGroup[]
  error?: string
  onChange: (value: string) => void
}

const UserGroupSection = memo(({ value, defaultOptions, error, onChange }: UserGroupSectionProps) => {
  const { t } = useTranslation();
  const handleUserGroupSelect = useCallback((selectedValue: any) => {
    onChange(selectedValue || "");
  }, [onChange]);

  return (
    <FormControl fullWidth error={!!error}>
      <CustomAsyncAutocomplete
        label={t('table.userGroup', 'User Group')}
        placeholder={t('escalation.selectUserGroup', 'Select user group...')}
        value={value}
        defaultOptions={defaultOptions}
        fetchOptions={fetchUsersForEscalation}
        queryKey="userGroupsForEscalation"
        labelKey="name"
        mainKey="_id"
        onSelect={handleUserGroupSelect}
        error={!!error}
        errorText={error}
      />
    </FormControl>
  )
})

export default UserGroupSection;